@if (selectedReq && selectedReq?.Request_Id) {
<div class="main-container requestDetails">
  <section id="timeline" class="timeline-outer">
    <div class=" container event-body-height selectedReq" id="content">
      <div class="row d-flex g-4">
        <div class="col s12 m12 l12">
          <ul class="timeline timeline-vertical">
            @if ((selectedReq?.Approver_Justification2 ||selectedReq?.Approver_2_ID) && selectedReq?.Req_Status ===
            'Approved') {
            <li class="event">
              <span class="progress-info-title card-heading table-Header-Nav-font pb-1"
                >{{
                  selectedReq?.Approver_2_timestamp ? (selectedReq?.Approver_2_timestamp | date: 'MMM d, y':'UTC') : ''
                }}<span class="ms-3">Approved</span></span
              >
              <div class="row progress-info no-padding appRejSec">
                <div class="col-3">
                  <label class="progress-info-title card-heading table-Header-Nav-font progress-info-col-header"
                    >Approved By</label
                  >
                  <div class="text-description progress-info-col-detail">{{ selectedReq?.Approver_2_Name || '' }}</div>
                </div>
                <div class="col-3">
                  <label class="progress-info-title card-heading table-Header-Nav-font progress-info-col-header"
                    >Comments
                  </label>
                  <div class="text-description progress-info-col-detail">
                    {{ selectedReq?.Approver_Justification2 || '' }}
                  </div>
                </div>
              </div>
            </li>
            } @if ((selectedReq?.Approver_Justification2 ||selectedReq?.Approver_2_ID) && selectedReq?.Req_Status ===
            'Rejected') {
            <li class="event">
              <span class="progress-info-title card-heading table-Header-Nav-font pb-1"
                >{{
                  selectedReq?.Approver_2_timestamp ? (selectedReq?.Approver_2_timestamp | date: 'MMM d, y':'UTC') : ''
                }}<span class="ms-3">Rejected</span>
              </span>
              <div class="row progress-info no-padding appRejSec">
                <div class="col-3">
                  <label class="progress-info-title card-heading table-Header-Nav-font progress-info-col-header"
                    >Rejected By</label
                  >
                  <div class="text-description progress-info-col-detail">{{ selectedReq?.Approver_2_Name || '' }}</div>
                </div>
                <div class="col-3">
                  <label class="progress-info-title card-heading table-Header-Nav-font progress-info-col-header"
                    >Comments
                  </label>
                  <div class="text-description progress-info-col-detail">
                    {{ selectedReq?.Approver_Justification2 || '' }}
                  </div>
                </div>
              </div>
            </li>
            } @if (selectedReq?.Req_Justification2 && selectedReq?.Req_Status == 'Cancelled') {
            <li class="event">
              <span class="progress-info-title card-heading table-Header-Nav-font pb-1"
                >{{ selectedReq?.updated_at ? (selectedReq?.updated_at | date: 'MMM d, y':'UTC') : ''
                }}<span class="ms-3">{{ selectedReq?.Req_Status }}</span>
              </span>
              <div class="row progress-info no-padding appRejSec">
                <div class="col-3">
                  <label class="progress-info-title card-heading table-Header-Nav-font progress-info-col-header"
                    >{{ selectedReq?.Req_Status }} By</label
                  >
                  <div class="text-description progress-info-col-detail">{{ selectedReq?.updated_by || '' }}</div>
                </div>
                <div class="col-3">
                  <label class="progress-info-title card-heading table-Header-Nav-font progress-info-col-header"
                    >Comments
                  </label>
                  <div class="text-description progress-info-col-detail">
                    {{ selectedReq?.Req_Justification2 || '' }}
                  </div>
                </div>
              </div>
            </li>
            } @if (selectedReq?.Req_Justification2 && selectedReq?.Req_Status != 'Cancelled') {
            <li class="event">
              <span class="progress-info-title card-heading table-Header-Nav-font pb-1"
                >{{ selectedReq?.updated_at | date: 'MMM d, y':'UTC' }}<span class="ms-3">User Justification 2</span>
              </span>
              <div class="text-description progress-info-col-detail">{{ selectedReq?.Req_Justification2 || '' }}</div>
            </li>
            } @if ((selectedReq?.Approver_1_ID || selectedReq?.Approver_Justification1) && (!selectedReq?.Approver_2_ID
            && !selectedReq?.Approver_Justification2) && (selectedReq?.Req_Status === 'Approved' ||
            selectedReq?.Req_Status === 'Rejected')) {
            <li class="event">
              <span class="progress-info-title card-heading table-Header-Nav-font pb-1"
                >{{
                  selectedReq?.Approver_1_timestamp ? (selectedReq?.Approver_1_timestamp | date: 'MMM d, y':'UTC') : ''
                }}
                <span class="ms-3">{{ selectedReq?.Req_Status }}</span></span
              >
              <div class="row progress-info no-padding appRejSec">
                <div class="col-3">
                  <label class="progress-info-title card-heading table-Header-Nav-font progress-info-col-header"
                    >{{ selectedReq?.Req_Status }} By</label
                  >
                  <div class="text-description progress-info-col-detail">{{ selectedReq?.Approver_1_Name || '' }}</div>
                </div>
                <div class="col-3">
                  <label class="progress-info-title card-heading table-Header-Nav-font progress-info-col-header"
                    >Comments
                  </label>
                  <div class="text-description progress-info-col-detail">
                    {{ selectedReq?.Approver_Justification1 || '' }}
                  </div>
                </div>
              </div>
            </li>
            } @if (((selectedReq?.Approver_1_ID || selectedReq?.Approver_Justification1) && (!selectedReq?.Approver_2_ID
            && !selectedReq?.Approver_Justification2) && selectedReq?.Req_Status === 'Open') || (selectedReq?.Req_Status
            !== 'Open' && (selectedReq?.Approver_2_ID || selectedReq?.Approver_Justification2)&&
            (selectedReq?.Approver_1_ID || selectedReq?.Approver_Justification1)) || (selectedReq?.Req_Status ==
            'Cancelled' && (selectedReq?.Req_Justification2)&& (selectedReq?.Approver_1_ID ||
            selectedReq?.Approver_Justification1))) {
            <li class="event">
              @if (selectedReq?.Req_Status === 'Open') {
              <span class="progress-info-title card-heading table-Header-Nav-font pb-1"
                >{{
                  selectedReq?.Approver_1_timestamp ? (selectedReq?.Approver_1_timestamp | date: 'MMM d, y':'UTC') : ''
                }}<span class="ms-3">More Information Requested</span>
              </span>
              } @if (selectedReq?.Req_Status !== 'Open') {
              <span class="progress-info-title card-heading table-Header-Nav-font pb-1"
                >{{
                  selectedReq?.Approver_1_timestamp ? (selectedReq?.Approver_1_timestamp | date: 'MMM d, y':'UTC') : ''
                }}
                <span class="ms-3">Approver Comment 1</span></span
              >
              }
              <div class="row progress-info no-padding appRejSec">
                <div class="col-3">
                  <label class="progress-info-title card-heading table-Header-Nav-font progress-info-col-header"
                    >Approver Name</label
                  >
                  <div class="text-description progress-info-col-detail">{{ selectedReq?.Approver_1_Name || '' }}</div>
                </div>
                <div class="col-3">
                  <label class="progress-info-title card-heading table-Header-Nav-font progress-info-col-header"
                    >Comments
                  </label>
                  <div class="text-description progress-info-col-detail">
                    {{ selectedReq?.Approver_Justification1 || '' }}
                  </div>
                </div>
              </div>
            </li>
            } @if (selectedReq) {
            <li class="event">
              <div class="progress-info-title-div ">
                <span class="progress-info-title card-heading table-Header-Nav-font pb-1">{{
                  selectedReq?.created_at | date: 'MMM d, y':'UTC'
                }}</span>
                <span class="ms-3 card-heading">Request Submitted</span>
              </div>
              <div class="progress-info progress-info-sm progress-info-width" [ngClass]="">
                <div class="row table-row1-spacer">
                  <div class=" col-4 details-column progress-info-col w-10">
                    <div class="progress-info-title card-heading table-Header-Nav-font progress-info-col-header">
                      Proposal ID
                    </div>
                    <div class="text-description progress-info-col-detail">{{ selectedReq?.Request_Id }}</div>
                  </div>
                  <div class="col-3 details-column progress-info-col w-14 ">
                    <div class="progress-info-title card-heading table-Header-Nav-font progress-info-col-header">
                      Funding Segment
                    </div>
                    <div class="text-description progress-info-col-detail">
                      {{ selectedReq?.Funding_Segment || '' }}
                    </div>
                  </div>
                  <div class="details-column col-4 progress-info-col w-10">
                    <div class="progress-info-title card-heading table-Header-Nav-font progress-info-col-header">
                      Funding Owner
                    </div>
                    <ul class="leader-hierarchy-detail-flex p-0 leader-hierarchy-scroll">
                      @for (owner of fundingOwnerLeaders; track owner; let i = $index) {
                      <li class="leader-hierarchy-detail-flex-inrow">
                        <span class="leader-heirarchy-user">{{ owner }}</span>
                      </li>
                      }
                    </ul>
                  </div>
                </div>
                <div class="row table-row2-spacer">
                  <div class="col-4 details-column progress-info-col w-14 ">
                    <div class="progress-info-title card-heading table-Header-Nav-font progress-info-col-header">
                      Portfolio Manager
                    </div>
                    <div class="text-description progress-info-col-detail">
                      {{ selectedReq?.Portfolio_Manager || '-' }}
                    </div>
                  </div>
                  <div class="col-3 details-column progress-info-col w-14 ">
                    <div class="progress-info-title card-heading table-Header-Nav-font progress-info-col-header">
                      UCMG Owner
                    </div>
                    <div class="text-description progress-info-col-detail">{{ selectedReq?.UCMG_Owner || '-' }}</div>
                  </div>
                  <div class="col-3 details-column progress-info-col w-16">
                    <div class="progress-info-title card-heading table-Header-Nav-font progress-info-col-header">
                      UCMG ID - Name
                    </div>
                    <div class="text-description progress-info-col-detail ">
                      {{ selectedReq?.UCMG_Id }} - {{ selectedReq?.UCMG_Name }}
                    </div>
                  </div>
                </div>
                <div class="row table-row2-spacer">
                  <div class="details-column col-4 progress-info-col w-10">
                    <div class="progress-info-title card-heading table-Header-Nav-font progress-info-col-header">
                      Leader Hierarchy
                    </div>
                    <ul class="leader-hierarchy-detail-flex p-0">
                      <li class="leader-hierarchy-detail-flex-inrow">
                        <div class="circle">
                          <span>L1</span>
                        </div>
                        <span class="leader-heirarchy-user">{{ selectedReq?.leader_level_1 || '' }}</span>
                      </li>
                      <li class="leader-hierarchy-detail-flex-inrow">
                        <div class="circle">
                          <span>L2</span>
                        </div>
                        <span class="leader-heirarchy-user">{{ selectedReq?.leader_level_2 || '' }}</span>
                      </li>
                      <li class="leader-hierarchy-detail-flex-inrow">
                        <div class="circle">
                          <span>L3</span>
                        </div>
                        <span class="leader-heirarchy-user">{{ selectedReq?.leader_level_3 || '' }}</span>
                      </li>
                    </ul>
                  </div>
                  <div class="details-column col-3 progress-info-col w-14">
                    <div class="progress-info-title card-heading table-Header-Nav-font progress-info-col-header">
                      Leader OT Labor Allocation
                    </div>
                    <div class="details-column-leader-ot-labor d-flex flex-column">
                      <div class="row">
                        <div class="progress-info-col-header col-5 pe-0">Current</div>
                        <div class="text-description progress-info-col-detail col-6 ps-0">
                          <span class="pe-1"> : </span
                          >{{
                            selectedReq?.preProposed_OT_Labor
                              ? (selectedReq?.preProposed_OT_Labor | currency: 'USD':'symbol':'1.0-0')
                              : '--'
                          }}
                        </div>
                      </div>
                      <div class="row">
                        <div class="progress-info-col-header col-5 pe-0">Proposed</div>
                        <div class="text-description progress-info-col-detail proposedOtSec col-6 ps-0">
                          @if (selectedOption === 'requests' && selectedReq?.Approver_Justification1 &&
                          selectedReq?.Req_Status === 'Open' && selectedReq?.Req_Justification2 == null &&
                          showPropOnDelete) {
                          <input
                            [(ngModel)]="proposalOT"
                            class="form-control pb-0 pt-0"
                            (ngModelChange)="calculatePostProposalOt(selectedReq, 'onChange')"
                            (keypress)="validateIntegerInput($event)"
                            style="appearance: textfield;"
                          />
                          } @else {
                          <span class="pe-1"> : </span
                          ><span>{{ selectedReq?.Proposed_OT_Labor | currency: 'USD':'symbol':'1.0-0' }}</span>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="details-column col-5 progress-info-col w-16">
                    <div class="progress-info-title card-heading table-Header-Nav-font progress-info-col-header">
                      UCMG OT Labor Allocation
                    </div>
                    <div class="details-column-ucmg-ot-labor d-flex flex-column">
                      <div class="row">
                        <div class="progress-info-col-header col-4 pe-0">Total OT Labor</div>
                        <div class="text-description progress-info-col-detail col-6 ps-0">
                          <span class="pe-1"> : </span
                          >{{ selectedReq?.Optum_Tech_Labour | currency: 'USD':'symbol':'1.0-0' }}
                        </div>
                      </div>
                      <div class="row">
                        <div class="progress-info-col-header col-4 pe-0">Remaining</div>
                        <div
                          class="text-description progress-info-col-detail col-6 ps-0"
                          [ngClass]="{ 'text-danger': selectedReq?.Optum_Tech_Labour - selectedReq?.totalOT <= -1 }"
                        >
                          <span class="pe-1"> : </span
                          >{{
                            selectedReq?.Optum_Tech_Labour - selectedReq?.totalOT | currency: 'USD':'symbol':'1.0-0'
                          }}
                        </div>
                      </div>
                      <div class="row">
                        <div class=" progress-info-col-header post-proposal-remaining-title col-4 pe-0">
                          Post Proposal Remaining
                        </div>
                        <div
                          class="text-description progress-info-col-detail col-6 ps-0"
                          [ngClass]="{ 'text-danger': postProposalOt <= -1 }"
                        >
                          <span class="pe-1"> : </span>{{ postProposalOt | currency: 'USD':'symbol':'1.0-0' }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row table-row2-spacer">
                  <div class="details-column col-4 progress-info-col w-10">
                    <div class="progress-info-title card-heading table-Header-Nav-font progress-info-col-header">
                      User Justification
                    </div>
                    <div class="text-description progress-info-col-detail">
                      {{ selectedReq?.Req_Justification1 || '' }}
                    </div>
                  </div>
                  <div class="details-column col-3 progress-info-col w-14">
                    <div class="progress-info-title card-heading table-Header-Nav-font progress-info-col-header">
                      Leader OT Labor Spend
                    </div>
                    <div class="details-column-leader-ot-labor d-flex flex-column">
                      <div class="row">
                        <div class="progress-info-col-header col-5 pe-0">Actuals</div>
                        <div class="text-description progress-info-col-detail col-6 ps-0">
                          <span class="pe-1"> : </span
                          >{{ selectedReq?.Actuals ? (selectedReq?.Actuals | currency: 'USD':'symbol':'1.0-0') : '--' }}
                        </div>
                      </div>
                      <div class="row">
                        <div class="progress-info-col-header col-5 pe-0">Run Rate</div>
                        <div class="text-description progress-info-col-detail proposedOtSec col-6 ps-0">
                          <ng-container>
                            <span class="pe-1"> : </span
                            ><span>{{ selectedReq?.Run_Rate | currency: 'USD':'symbol':'1.0-0' }}</span>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="details-column col-3 progress-info-col w-14">
                    <div class="progress-info-title card-heading table-Header-Nav-font progress-info-col-header">
                      UCMG OT Labor Spend
                    </div>
                    <div class="details-column-leader-ot-labor d-flex flex-column">
                      <div class="row">
                        <div class="progress-info-col-header col-5 pe-0">Actuals</div>
                        <div class="text-description progress-info-col-detail col-6 ps-0">
                          <span class="pe-1"> : </span
                          >{{
                            selectedReq?.ucmgActuals
                              ? (selectedReq?.ucmgActuals | currency: 'USD':'symbol':'1.0-0')
                              : '--'
                          }}
                        </div>
                      </div>
                      <div class="row">
                        <div class="progress-info-col-header col-5 pe-0">Run Rate</div>
                        <div class="text-description progress-info-col-detail proposedOtSec col-6 ps-0">
                          <ng-container>
                            <span class="pe-1"> : </span
                            ><span>{{ selectedReq?.ucmgrunRate | currency: 'USD':'symbol':'1.0-0' }}</span>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            }
            <li class="event"></li>
          </ul>
          @if (selectedOption === 'requests' && selectedReq?.Req_Status === 'Open' &&
          selectedReq?.Approver_Justification1 != null && selectedReq?.Req_Justification2 == null) {
          <div class="col-md-12 col-xs-12 col-sm-12 col-lg-12 col-xl-12 col-xs-12 comment-or-justification-spacer">
            <div class="progress-info-title card-heading table-Header-Nav-font progress-info-col-header textBoxHeading">
              Enter Justification 2
            </div>
            <textarea
              class="resizeTextArea"
              type="textarea"
              class="form-control"
              [(ngModel)]="justification2Text"
              (input)="enableRejectButton('ReqJust2')"
              required
              minlength="3"
              maxlength="330"
            ></textarea>
          </div>
          } @if (selectedOption === 'approvals' && selectedReq?.Req_Status === 'Open' &&
          ((selectedReq?.Approver_Justification1 && selectedReq?.Req_Justification2)
          ||(!selectedReq?.Approver_Justification1 && !selectedReq?.Req_Justification2))) {
          <div class="col-md-12 col-xs-12 col-sm-12 col-lg-12 col-xl-12 col-xs-12 comment-or-justification-spacer">
            <div class="progress-info-title card-heading table-Header-Nav-font progress-info-col-header textBoxHeading">
              Enter Comments to request more information or Approve or Reject the Request
            </div>
            <textarea
              class="resizeTextArea"
              type="textarea"
              class="form-control"
              [(ngModel)]="appJustificationText"
              (input)="enableRejectButton('AppJust')"
              required
              minlength="3"
              maxlength="330"
            ></textarea>
          </div>
          }
          <div class="row padu-update-btn-block maintainHeightActionBt mt-3">
            <div class="col-md-6" class="approveAndRejectButonAln"></div>
            @if (selectedOption === 'requests' && selectedReq?.Approver_Justification1 && selectedReq?.Req_Status ===
            'Open') {
            <div class="user-action-buttons">
              <button
                mat-mdc-raised-button
                (click)="onCancelClick()"
                class="m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs  button-size"
              >
                Cancel
              </button>
              @if (selectedReq?.Req_Justification2 == null) {
              <button
                style="margin-right:9px"
                mat-mdc-raised-button
                [disabled]="rejectButtonDisabled"
                (click)="onUpdateClick()"
                class="m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u_margin-bottom--xs  button-size"
              >
                Update
              </button>
              }
            </div>
            } @if (selectedOption === 'approvals' && selectedReq?.Req_Status === 'Open' &&
            ((selectedReq?.Approver_Justification1 && selectedReq?.Req_Justification2)
            ||(!selectedReq?.Approver_Justification1 && !selectedReq?.Req_Justification2))) {
            <div class="user-action-buttons">
              <button
                mat-mdc-raised-button
                [disabled]="rejectButtonDisabled"
                class="m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs  button-size"
                (click)="onRejectClick()"
              >
                Reject
              </button>
              <button
                style="margin-right:9px"
                mat-mdc-raised-button
                (click)="onApproveClick()"
                class="m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs  button-size"
              >
                Approve
              </button>
              @if (!selectedReq?.Approver_Justification1) {
              <button
                (click)="onReqDetailClick()"
                style="margin-right:9px"
                mat-mdc-raised-button
                [disabled]="rejectButtonDisabled"
                class="m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs  button-size"
              >
                Request Information
              </button>
              }
            </div>
            }
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
}

<app-modal [maximizable]="true" [inViewport]="true" #cancelOpenRequest class="modal-demo add-comment-modal">
  <ng-container class="app-modal-header">Cancel Request</ng-container>
  <ng-container class="app-modal-body">
    <div class="mb-3">
      <p>Are you sure you want to cancel the request?</p>
    </div>
  </ng-container>
  <ng-container class="app-modal-body">
    <div class="add-edit-master-data-block">
      <div style="width: auto;">
        <p style="color: #013B71;font-weight: bold;">
          Comment
          <span class="mandate-asterisk uitk-icon uitk-icon-asterisk sm-icon"></span>
        </p>
        <div class="form-field">
          <p class="m-0">
            <textarea
              placeholder="Please enter your Justification"
              (input)="fieldValueChange()"
              name="comment"
              [(ngModel)]="comment"
              class="w-100 form-control comments-input"
              rows="4"
            ></textarea>
          </p>
        </div>
      </div>

      <button
        style="float: right;"
        [disabled]="!isInValidData"
        class="m-3 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs"
        (click)="confirmCancel()"
      >
        Continue
      </button>
    </div>
  </ng-container>
</app-modal>
